import { Metadata } from '../../../../utils/spds/metadata';
import { TrackedObject } from 'tracked-built-ins';
import { service } from '@ember/service';
import { testAwareWaitForLater } from '../../../../utils/waiters';
import FlexRow from '../../layout/flex/row.gjs';
import Message from './message.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: `
Global-level alert banner container that displays a single banner message dispatched via the alert manager service
  `,
  name: 'Alert Banner Global Container',
});

export default class SpdsFeedbackAlertBannerGlobalContainer extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-alert-banner-global-container';
  messageData = new TrackedObject();

  @service alertManager;

  get displayMessage() {
    return Object.keys(this.messageData).length > 0;
  }

  get dismissOnCloseBtn() {
    let { closeable, onClose } = this.messageData;

    return closeable || onClose ? this.dismiss : null;
  }

  constructor() {
    super(...arguments);

    this.bindServiceEvents();
  }

  bindServiceEvents() {
    let events = [
      {
        context: this,
        event: 'clearBanner',
        handler: this.dismissBanner,
      },
      {
        context: this,
        event: 'displayBanner',
        handler: this.displayBanner,
      },
    ];

    events.forEach(event => this.alertManager.bindEventHandler(event));
  }

  async dismissBanner() {
    let { onClose } = this.messageData;

    Object.keys(this.messageData).forEach(key => delete this.messageData[key]);

    if (onClose) {
      onClose();
    } else {
      await testAwareWaitForLater(300);
    }
  }

  displayBanner(messageDataObj) {
    Object.assign(this.messageData, messageDataObj);
  }

  dismiss = async () => {
    await this.dismissBanner();
  };

  <template>
    <FlexRow
      @fitContentHeight={{true}}
      class={{this.classes}}
      data-test-spds-feedback-alert-banner-global-container
      ...attributes
    >
      {{#if this.displayMessage}}
        <Message
          @body={{this.messageData.body}}
          @ctaAlignment={{this.messageData.ctaAlignment}}
          @global={{true}}
          @header={{this.messageData.header}}
          @includeIcon={{this.messageData.includeIcon}}
          @onClose={{this.dismissOnCloseBtn}}
          @onPrimaryBtnClick={{this.messageData.onPrimaryBtnClick}}
          @onSecondaryBtnClick={{this.messageData.onSecondaryBtnClick}}
          @primaryBtnText={{this.messageData.primaryBtnText}}
          @secondaryBtnText={{this.messageData.secondaryBtnText}}
          @type={{this.messageData.type}}
        />
      {{/if}}
    </FlexRow>
  </template>
}

export const ALERT_BANNER_GLOBAL_CONTAINER_METADATA =
  SpdsFeedbackAlertBannerGlobalContainer.metadata;
